import {SidebarNode} from '../../_shared/nav/nav.interfaces';

export class ProjectViewNav {
    public static getProjectCreateNav(folder: number, isDisabled: any): SidebarNode[] {
        const getStepUrl = (step) => {
            if (step == 0) {
              if (Number.isInteger(folder)) {
                return ['carpetas', folder];
              } else {
                return ['carpetas'];
              }
            } else {
              if (Number.isInteger(folder)) {
                return ['crear-proyecto', {step: step, folder: folder}];
              } else {
                return ['crear-proyecto', {step: step}];
              }
            }
        };
        return ProjectViewNav.getProjectNav(getStepUrl, isDisabled);
    }

    public static getProjectEditNav(id: number, folder: number, isDisabled: any): SidebarNode[] {
        const getStepUrl = (step) => {
          if (step == 0) {
            if (Number.isInteger(folder)) {
              return ['carpetas', folder];
            } else {
              return ['carpetas'];
            }
          } else {
            return ['proyecto', id, {step: step}];
          }
        };
        return ProjectViewNav.getProjectNav(getStepUrl, isDisabled);
    }

    private static getProjectNav(getStepUrl: any, isDisabled: any): SidebarNode[] {
        return [

            {
                label: '1 Ficha de Proyecto',
                url: getStepUrl('1'),
                disabled: () => isDisabled(1),
                children: []
            },
            {
                label: '2 Geometría',
                url: getStepUrl('2'),
                disabled: () => isDisabled(2),
                children: []
            },
            {
                label: '3 Cargas y Revestimientos',
                url: getStepUrl('3'),
                disabled: () => isDisabled(3),
                children: []
            },
            {
                label: '4 Elección Marco',
                url: getStepUrl('4'),
                disabled: () => isDisabled(4),
                children: []
            },
            {
                label: '5 Elementos Secundarios',
                url: getStepUrl('5'),
                disabled: () => isDisabled(5),
                children: []
            },
            {
                label: '6 Exportar',
                url: getStepUrl('6'),
                disabled: () => isDisabled(6),
                children: []
            },
            {
                label: 'Volver',
                url: getStepUrl('0'),
                disabled: () => isDisabled(1),
                children: [],
                hide: true
            },
        ];
    };
}



// WEBPACK FOOTER //
// ./src/app/project/project-view/project-view.nav.ts